// tourSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {ListToursAvailables, StepRaw, TourStep} from "@app-types/tour.types.ts";

export interface TourState {
    isTourOpen: boolean;
    currentStep: number;
    steps: TourStep[];
    stepsRawList: ListToursAvailables;
}

const initialState: TourState = {
    isTourOpen: false,
    currentStep: 0,
    steps: [],
    stepsRawList: {}, // Inicializa correctamente como un objeto vacío
};

const tourSlice = createSlice({
    name: 'tour',
    initialState,
    reducers: {
        setStepsRaw: (state, action: PayloadAction<StepRaw>) => {
            // Actualiza de forma inmutable el stepsRawList
            state.stepsRawList = {
                ...state.stepsRawList,
                [action.payload.tourName]: action.payload.stepsRaw
            };
        },
        startTour: (state, action: PayloadAction<{ steps: TourStep[], stepsRawList?: StepRaw }>) => {
            state.isTourOpen = true;
            state.currentStep = 0;
            state.steps = action.payload.steps;

            // Solo actualiza stepsRawList si se proporciona
            if (action.payload.stepsRawList) {
                state.stepsRawList[action.payload.stepsRawList.tourName] = action.payload.stepsRawList.stepsRaw;
            }
        },
        nextStepTour: (state) => {
            if (state.currentStep < state.steps.length - 1) {
                state.currentStep += 1;
            }
        },
        prevStepTour: (state) => {
            if (state.currentStep > 0) {
                state.currentStep -= 1;
            }
        },
        endTour: (state) => {
            state.isTourOpen = false;
            state.currentStep = 0;
            state.steps = [];
        },
        setTourStep: (state, action: PayloadAction<number>) => {
            // Solo actualiza el paso si está dentro del rango de los steps
            if (action.payload >= 0 && action.payload < state.steps.length) {
                state.currentStep = action.payload;
            }
        },
    },
});

export const {
    startTour,
    nextStepTour,
    prevStepTour,
    endTour,
    setTourStep,
    setStepsRaw,
} = tourSlice.actions;

export default tourSlice.reducer;
